import React, { useRef, useState } from "react";
import BaseModal from "../../modals/base-modal";
import FormField from "../../forms/form-field";
import { instanceMob } from "../../../utils/utils";
import useLocationStore from "../config/use-location-store";
import InlineModal from "../../info-modal/infoModal";
import {getBackendError} from "../../../utils/error-helpers";

const CreateProviderModal = ({ show, onClose }) => {
    const formRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const [infoModal, setInfoModal] = useState(null);
    const selectedLocation = useLocationStore((state) => state.selectedLocation);

    const formFields = [
        { Component: FormField, label: "Nombre del proveedor", name: "name", type: "text", placeholder: "Escribe aquí", required: true, isLoading },
        { Component: FormField, label: "NIT", name: "nit", type: "text", placeholder: "Escribe aquí", required: true, isLoading },
        { Component: FormField, label: "Dirección", name: "address", type: "text", placeholder: "Escribe aquí", required: true, isLoading },
        { Component: FormField, label: "Teléfono", name: "phone", type: "text", placeholder: "Escribe aquí", required: true, isLoading },
        { Component: FormField, label: "Ciudad", name: "city", type: "text", placeholder: "Escribe aquí", required: true, isLoading },
        { Component: FormField, label: "Correo Electrónico", name: "email", type: "email", placeholder: "Escribe aquí", required: true, isLoading },
    ];

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);

        const formData = new FormData(formRef.current);
        const payload = Object.fromEntries(formData.entries());

        instanceMob
            .post("admin/accounting/provider/create", payload)
            .then((response) => {
                const provider = response?.data;
                setInfoModal({
                    iconType: "success",
                    title: "Proveedor creado",
                    description: "El proveedor fue registrado con éxito.",
                    primaryAction: {
                        label: "Aceptar",
                        onClick: () => {
                            setInfoModal(null);
                            onClose(provider);
                        },
                    },
                });
            })
            .catch((err) => {
                const errorMessage = getBackendError(err);
                setInfoModal({
                    iconType: "error",
                    title: "Error",
                    description: errorMessage,
                    secondaryAction: {
                        label: "Cerrar",
                        onClick: () => setInfoModal(null),
                    },
                });
            })
            .finally(() => {
                setIsLoading(false);
            });
    };


    return (
        <>
            <BaseModal
                show={show}
                onClose={() => onClose()}
                title="Registrar tercero"
                onSave={() => formRef.current?.requestSubmit()}
                saveButtonText="Crear"
            >
                <form
                    className="d-flex flex-column gap-2"
                    ref={formRef}
                    onSubmit={handleSubmit}
                >
                    {formFields.map((field, index) => {
                        const FieldComponent = field.Component;
                        return (
                            <FieldComponent
                                key={index}
                                id={field.name}
                                {...field}
                            />
                        );
                    })}

                    <input
                        type="hidden"
                        name="location_id"
                        value={selectedLocation?.id || ""}
                    />
                </form>
            </BaseModal>
            {infoModal && (
                <InlineModal
                    icon={infoModal.icon}
                    iconType={infoModal.iconType}
                    title={infoModal.title}
                    description={infoModal.description}
                    primaryAction={infoModal.primaryAction}
                    secondaryAction={infoModal.secondaryAction}
                />
            )}
        </>
    );
};

export default CreateProviderModal;
